<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="getAllDailyDiscountDetails">
    <template #title> آمار تخفیف های روزانه </template>

    <template #filters>
      <CustomDatePicker class="w-24 filters-width" inputId="dailyStartDate" :value="dailyDiscountFilters.startDate"
        @getSelectedDate="setStartDate" inputLabel="تاریخ شروع بازه" inputPlaceholder="1403/06/05">
      </CustomDatePicker>

      <CustomDatePicker class="w-24 filters-width" inputId="dailyEndDate" :value="dailyDiscountFilters.endDate"
        @getSelectedDate="setEndDate" inputLabel="تاریخ پایان بازه" inputPlaceholder="1403/06/05">
      </CustomDatePicker>
      <price-category-picker
              @getPriceCategory="setPriceCategory"
              class="w-24 filters-width"
            ></price-category-picker>
    </template>
    <CustomTable
        v-if="dailyDiscountList"
        :pageNumber="dailyDiscountFilters.pageNumber"
        :count="dailyDiscountFilters.count"
        :totalCount="totalCount"
        :tableColumns="tableColumns2"
        :tableItems="dailyDiscountList.data"
        @changePage="changePage"
    >
      
      <template #discunt3Count="data">
        {{ data.item.discunt3Count}}
        نفر
      </template>
       <template #discunt3="data">
        {{ Intl.NumberFormat("en-US").format(data.item.discunt3)}}
        تومان
      </template>
      <template #discunt7Count="data">
        {{ data.item.discunt7Count }}
        نفر
      </template>
      <template #discunt7="data">
        {{ Intl.NumberFormat("en-US").format(data.item.discunt7)}}
        تومان
      </template>
      <template #totalDiscunt="data">
        {{ Intl.NumberFormat("en-US").format(data.item.totalDiscunt)}}
        تومان
      </template>
    </CustomTable>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.setEndDate(new Date());
    this.getDicountDayReport()
  },
  data() {
    return {
      isLoading: false,
      dailyDiscountList: null,
      tableColumns: [

      ],


      tableColumns2: [
        {
          key: "priceCateogryId",
          label: "شناسه",
        },
        
        //need to added by backEnd
        {
          key: "priceCateogryName",
          label: "گروه‌بندی",
        },
        {
          key: "discunt3Count",
          label: "3 درصد",
        },
        {
          key: "discunt3",
          label: "مبلغ کل 3 درصد",
        },
        {
          key: "discunt3Count",
          label: "7 درصد",
        },
        {
          key: "discunt3",
          label: "مبلغ کل 7 درصد",
        },
        {
          key: "totalDiscuntCount",
          label: "تعداد کل",
        },
        {
          key: "totalDiscunt",
          label: "مبلغ کل",
        },
        
      ],

      dailyDiscountFilters: {
        pageNumber: 1,
        count: 10,
        startDate: null,
        endDate: null,
        userId: null,
        day: null,
        dicount: null
      },
      totalCount: null,
    };
  },
  methods: {
    async getAllDailyDiscountDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllUserScheduleDiscount = new GetAllUserScheduleDiscount(
            _this
        );
        getAllUserScheduleDiscount.setRequestParam(_this.dailyDiscountFilters);
        await getAllUserScheduleDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.dailyDiscountList = res.data;
            console.log(_this.dailyDiscountList);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },


    setPriceCategory(priceCategoryId) {
      this.incomeOutcomeCashFilters.priceCategoryId = priceCategoryId;
    },


    async getDicountDayReport() {
      try {
        this.isLoading = true;
        const _this = this;
        const getDicountDayReport = new GetDicountDayReport(
            _this
        );
        getDicountDayReport.setRequestParamDataObj(_this.dailyDiscountFilters);
        await getDicountDayReport.fetch((res) => {
          if (res.isSuccess) {
            _this.dailyDiscountList = res.data;
            _this.totalCount = res.data.total
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },


   
    setStartDate(date) {
      this.dailyDiscountFilters.startDate = new Date(date).toISOString();
      if (date) {
        this.calculateEndDateFromStartDate(date);
      } else {
        this.dailyDiscountFilters.startDate = null;
        this.dailyDiscountFilters.endDate = null;
      }
    },
    setEndDate(date) {
      this.dailyDiscountFilters.endDate = new Date(date).toISOString();
      if (date) {
        this.calculateStartDateFromEndDate(date);
      } else {
        this.dailyDiscountFilters.startDate = null;
        this.dailyDiscountFilters.endDate = null;
      }
    },
    calculateStartDateFromEndDate(date) {
      this.dailyDiscountFilters.startDate = new Date(
          new Date().setDate(new Date(date).getDate() - 7)
      ).toISOString();
    },
    calculateEndDateFromStartDate(date) {
      this.dailyDiscountFilters.endDate = new Date(
          new Date(date).setDate(new Date(date).getDate() + 7)
      ).toISOString();
    },


    changePage(pageNumber) {
      this.dailyDiscountFilters.pageNumber = pageNumber;
      this.getDiscountDayStudent();
    },

    async fetchData(){
      this.dailyDiscountFilters.pageNumber = 1
      await this.getDiscountDayStudent()
    },
  },


  components: {
    PageWrapper,
    CustomDatePicker,
    CustomTable,
    PriceCategoryPicker,

  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetAllUserScheduleDiscount } from "@/libs/Api/Schedules";
import { GetDicountDayReport } from "@/libs/Api/Schedules";import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";

</script>


<!--
<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="fetchData"
  >
    <template #title> آمار تخفیف های روزانه </template>

    <template #filters>

      <CustomDatePicker
        class="w-24 filters-width"
        inputId="dailyStartDate"
        :value="Filters.startDate"
        @getSelectedDate="setStartDate"
        inputLabel="تاریخ شروع بازه"
        inputPlaceholder="1403/06/05"
      >
      </CustomDatePicker>

      <CustomDatePicker
        class="w-24 filters-width"
        inputId="dailyEndDate"
        :value="Filters.endDate"
        @getSelectedDate="setEndDate"
        inputLabel="تاریخ پایان بازه"
        inputPlaceholder="1403/06/05"
      >
      </CustomDatePicker>

    </template>
    <CustomTable
        v-if="dailyDiscountList"
        :pageNumber="Filters.pageNumber"
        :count="Filters.count"
        :totalCount="totalCount"
        :tableColumns="tableColumns2"
        :tableItems="dailyDiscountList"
        @changePage="changePage"
    >

      // <template #noDiscount="data">{{ getDiscountedItem(data.item.details, 0) }}نفر</template><template #fivePercentDiscount="data">  {{ getDiscountedItem(data.item.details, 5) }}  نفر</template><template #tenPercentDiscount="data">  {{ getDiscountedItem(data.item.details, 10) }}  نفر</template>

</CustomTable>
</PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.setEndDate(new Date());
    this.getDiscountDayStudent()
  },
  data() {
    return {
      isLoading: false,
      dailyDiscountList: null,
      tableColumns: [

      ],


      tableColumns2: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "studentUserId",
          label: "شناسه 1",
        },
        {
          key: "studentName",
          label: "شناسه 2",
        },
        {
          key: "days",
          label: "روز",
        },
        {
          key: "discunt",
          label: "مقدار تخفیف",
        },
        {
          key: "discuntPercentage",
          label: "درصد تخفیف",
        },
        {
          key: "createDate",
          label: "تاریخ",
        },

        //need to added by backEnd
        {
          key: "priceCategory",
          label: "گروه‌بندی",
        },
        {
          key: "noDiscount",
          label: "بدون تخفیف",
        },
        {
          key: "fivePercentDiscount",
          label: "5 درصد",
        },
        {
          key: "tenPercentDiscount",
          label: "10 درصد",
        },
      ],

      Filters: {
        pageNumber: 1,
        count: 10,
        startDate: null,
        endDate: null,
        userId: null,
        day: null,
        dicount: null
      },
      totalCount: null,
    };
  },
  methods: {
    async getAllDailyDiscountDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllUserScheduleDiscount = new GetAllUserScheduleDiscount(
            _this
        );
        getAllUserScheduleDiscount.setRequestParam(_this.dailyDiscountFilters);
        await getAllUserScheduleDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.dailyDiscountList = res.data;
            console.log(_this.dailyDiscountList);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },




    async getDiscountDayStudent() {
      try {
        this.isLoading = true;
        const _this = this;
        const getDicountDayStudent = new GetDicountDayStudent(
            _this
        );
        getDicountDayStudent.setRequestParamDataObj(_this.Filters);
        await getDicountDayStudent.fetch((res) => {
          if (res.isSuccess) {
            _this.dailyDiscountList = res.data;
            _this.totalCount = response.data.total
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },


    getDiscountedItem(details, neededPercent) {
      if (details && details.length) {
        return (
            details.find((item) => item.discount == neededPercent)?.count || 0
        );
      }
    },
    setStartDate(date) {
      this.Filters.startDate = new Date(date).toISOString();
      if (date) {
        this.calculateEndDateFromStartDate(date);
      } else {
        this.Filters.startDate = null;
        this.Filters.endDate = null;
      }
    },
    setEndDate(date) {
      this.Filters.endDate = new Date(date).toISOString();
      if (date) {
        this.calculateStartDateFromEndDate(date);
      } else {
        this.Filters.startDate = null;
        this.Filters.endDate = null;
      }
    },
    calculateStartDateFromEndDate(date) {
      this.Filters.startDate = new Date(
          new Date().setDate(new Date(date).getDate() - 7)
      ).toISOString();
    },
    calculateEndDateFromStartDate(date) {
      this.Filters.endDate = new Date(
          new Date(date).setDate(new Date(date).getDate() + 7)
      ).toISOString();
    },


    changePage(pageNumber) {
      this.Filters.pageNumber = pageNumber;
      this.getDiscountDayStudent();
    },

    async fetchData(){
      this.Filters.pageNumber = 1
      await this.getDiscountDayStudent()
    },
  },


  components: {
    PageWrapper,
    CustomDatePicker,
    CustomTable,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetAllUserScheduleDiscount } from "@/libs/Api/Schedules";
import { GetDicountDayStudent } from "@/libs/Api/Schedules";
</script>

-->